import {Component, EventEmitter, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {LanguageHelper} from '../../core/utilities/language-helper';
import {ProMessagingWhatsAppTemplateService} from '../pro-messaging-whats-app-template.service';
import {WhatsAppMessagingTemplateModel} from '../../api/models/whats-app-messaging-template-model';
import {WhatsAppTemplateComponentModel} from '../../api/models/whats-app-template-component-model';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WhatsAppSendTemplateModel} from '../../api/models/whats-app-send-template-model';
import {WhatsAppSendTemplateComponentModel} from '../../api/models/whats-app-send-template-component-model';
import {NotificationService} from '../../notification/notification.service';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { ProMessagingWhatsAppTemplatesGridComponent } from '../list/grid/pro-messaging-whats-app-templates-grid.component';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatLabel } from '@angular/material/form-field';
import { TemplateUploadInputComponent } from '../template-upload-input/template-upload-input.component';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatTooltip } from '@angular/material/tooltip';
import { LanguagePipe } from '../../core/pipes/language.pipe';

@Component({
    selector: 'app-whatsapp-template-dialog',
    templateUrl: './select-whatsapp-template-dialog.component.html',
    styleUrls: ['./select-whatsapp-template-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        GridFilterComponent,
        ProMessagingWhatsAppTemplatesGridComponent,
        MatCard,
        MatCardTitle,
        MatCardContent,
        FormsModule,
        ReactiveFormsModule,
        MatLabel,
        TemplateUploadInputComponent,
        MatTextInputComponent,
        NgFor,
        MatButton,
        MatTooltip,
        MatDialogActions,
        LanguagePipe,
    ],
})
export class SelectWhatsappTemplateDialogComponent implements OnInit, OnDestroy {

  filterChangeEvent = new EventEmitter<any>();
  filterOptions: FilterOptionModel[] = [];

  selectedTemplate: WhatsAppMessagingTemplateModel;

  templateHeaderObj: WhatsAppTemplateComponentModel;
  templateBodyObj: WhatsAppTemplateComponentModel;
  templateFooterObj: WhatsAppTemplateComponentModel;
  templateButtonsObj: WhatsAppTemplateComponentModel;

  file1: File | Blob;
  form: UntypedFormGroup;

  headerAttachmentForm: { index: number; key: string; name: string; value: File, mimeTypes: string };
  headerForm: { index: number; key: string; name: string; value: string };
  bodyForm: Array<{ index: number; key: string; name: string; value: string }> = [];
  buttonsForm: Array<{ index: number; key: string; name: string; value: string }> = [];

  constructor(public dialogRef: MatDialogRef<SelectWhatsappTemplateDialogComponent>,
              public templateService: ProMessagingWhatsAppTemplateService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private fb: UntypedFormBuilder,
              private notificationService: NotificationService,
  ) {

  }

  onFilterChanged(filter: any) {
    console.log(filter);
    filter['status'] = 'APPROVED';
    filter['wabaIds'] = [this.data.wabaId];
    this.filterChangeEvent.emit(filter);
  }

  ngOnInit() {
    this.initFilterOptions();
    this.onFilterChanged({});
  }

  ngOnDestroy() {

  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'name',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Name'
      },
    ];

    for (const item of LanguageHelper.languageList) {
      this.filterOptions.push({
        filterKey: 'language',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Language',
        displayValue: item.name,
        value: item.code.replace('-', '_'),
        searchText: `Language: ${item.name} ${item.code.replace('-', '_')}`,
      });
    }

    for (const item of this.templateService.templateCategories) {
      this.filterOptions.push({
        filterKey: 'category',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Category',
        displayValue: item.text,
        value: item.id,
        searchText: `Category: ${item.text} ${item.id}`,
      });
    }
  }

  onTemplateSelected(item: WhatsAppMessagingTemplateModel) {
    console.log('onTemplateSelected', item);
    this.selectedTemplate = item;

    this.templateHeaderObj = item.components.find(x => x.type === 'HEADER');
    this.templateBodyObj = item.components.find(x => x.type === 'BODY');
    this.templateFooterObj = item.components.find(x => x.type === 'FOOTER');
    this.templateButtonsObj = item.components.find(x => x.type === 'BUTTONS');

    const paramRegex = /{{\d}}/gm;

    if (this.templateHeaderObj?.text && this.templateHeaderObj?.text.indexOf('{{1}}') > -1) {
      this.headerForm = {
        index: 1,
        key: '{{1}}',
        name: 'param1',
        value: ''
      };
    }

    if (this.templateHeaderObj?.format === 'IMAGE') {
      this.headerAttachmentForm = {
        index: 1,
        key: 'IMAGE',
        name: 'image1',
        value: undefined,
        mimeTypes: 'image/jpeg,image/png'
      };
    }

    if (this.templateHeaderObj?.format === 'DOCUMENT') {
      this.headerAttachmentForm = {
        index: 1,
        key: 'DOCUMENT',
        name: 'document1',
        value: undefined,
        mimeTypes: 'application/pdf'
      };
    }

    if (this.templateHeaderObj?.format === 'VIDEO') {
      this.headerAttachmentForm = {
        index: 1,
        key: 'VIDEO',
        name: 'video1',
        value: undefined,
        mimeTypes: 'video/mp4,video/3gpp'
      };
    }


    if (this.templateBodyObj?.text) {
      const bodyParams = this.templateBodyObj.text.match(paramRegex);
      let index = 1;
      for (const bodyParam of (bodyParams || [])) {
        this.bodyForm.push({
          key: bodyParam,
          name: `body_param${index}`,
          index: index,
          value: ''
        });

        index++;
      }
    }

    if (this.templateButtonsObj && this.templateButtonsObj.buttons) {
      let index = 1;
      for (const button of this.templateButtonsObj.buttons) {
        if (button.type === 'QUICK_REPLY' || (button.type === 'URL' && (button.url || '').indexOf('{{1}}') !== -1)) {
          this.buttonsForm.push({
            key: button.type,
            name: `button_param${index}`,
            index: index,
            value: ''
          });
        }
        index++;
      }
    }

    const fromConfig = {};

    if (this.headerForm) {
      fromConfig[this.headerForm.name] = new UntypedFormControl(this.headerForm.value, [Validators.required]);
    }

    if (this.bodyForm && this.bodyForm.length > 0) {
      for (const bodyFormElement of this.bodyForm) {
        fromConfig[bodyFormElement.name] = new UntypedFormControl(bodyFormElement.value, [Validators.required]);
      }
    }

    if (this.buttonsForm && this.buttonsForm.length > 0) {
      for (const buttonForm of this.buttonsForm) {
        fromConfig[buttonForm.name] = new UntypedFormControl(buttonForm.value, [Validators.required]);
      }
    }

    this.form = this.fb.group(fromConfig);
  }

  backToList() {
    this.selectedTemplate = undefined;
    this.templateHeaderObj = undefined;
    this.templateBodyObj = undefined;
    this.templateFooterObj = undefined;
    this.templateButtonsObj = undefined;

    this.headerForm = undefined;
    this.bodyForm = [];
    this.buttonsForm = [];
  }

  previewHeader() {
    if (!this.templateHeaderObj) {
      return '';
    }
    const templateText = this.templateHeaderObj?.text;
    if (templateText && this.headerForm) {
      const currentValue = this.form.get(this.headerForm.name).value;
      if (this.headerForm.key && currentValue) {
        return templateText.replace(this.headerForm.key, currentValue);
      } else {
        return templateText;
      }
    }
    return templateText;
  }

  previewBody() {
    if (!this.templateBodyObj) {
      return '';
    }
    let templateText = this.templateBodyObj?.text;
    if (templateText && this.bodyForm) {
      for (const bodyFormElement of this.bodyForm) {
        const currentValue = this.form.get(bodyFormElement.name).value;
        if (bodyFormElement.key && currentValue) {
          templateText = templateText.replace(bodyFormElement.key, currentValue);
        }
      }
    }
    return templateText;
  }

  getFormControl(controlName: string, otherForm?: UntypedFormGroup | AbstractControl): UntypedFormControl {
    if (otherForm) {
      return otherForm.get(controlName) as UntypedFormControl;
    } else {
      return this.form.get(controlName) as UntypedFormControl;
    }
  }

  onFileValidationError($event: string) {
    this.notificationService.notifyDanger($event);
  }

  onFileChanged($event: File | Blob) {
    console.log('On file 1 changed', $event);
    this.file1 = $event;
  }

  onSubmit() {
  }

  sendTemplate() {
    console.log(this.form.valid);
    if (this.form.valid) {
      const template: WhatsAppSendTemplateModel = {
        name: this.selectedTemplate.name,
        languageCode: this.selectedTemplate.language,
        components: []
      };

      const formValues = this.form.getRawValue();

      if (this.headerForm?.key) {
        template.components.push({
          type: 'header',
          parameters: [
            {type: 'text', text: formValues[this.headerForm.name]}
          ]
        });
      }

      if (this.headerAttachmentForm && this.headerAttachmentForm.key === 'IMAGE' && this.file1) {
        template.components.push({
          type: 'header',
          parameters: [
            {type: 'image', image: {id: ''}}
          ]
        });
      }

      if (this.headerAttachmentForm && this.headerAttachmentForm.key === 'DOCUMENT' && this.file1) {
        template.components.push({
          type: 'header',
          parameters: [
            {type: 'document', document: {id: ''}}
          ]
        });
      }

      if (this.headerAttachmentForm && this.headerAttachmentForm.key === 'VIDEO' && this.file1) {
        template.components.push({
          type: 'header',
          parameters: [
            {type: 'video', video: {id: ''}}
          ]
        });
      }

      if (this.bodyForm && this.bodyForm.length > 0) {
        const bodyComponent = {
          type: 'body',
          parameters: []
        };
        for (const bodyFormElement of this.bodyForm) {
          bodyComponent.parameters.push({type: 'text', text: formValues[bodyFormElement.name]});
        }

        template.components.push(bodyComponent);
      }

      if (this.buttonsForm && this.buttonsForm.length > 0) {
        for (const buttonForm of this.buttonsForm) {
          const buttonConfig: WhatsAppSendTemplateComponentModel = {
            type: 'button',
            sub_type: buttonForm.key.toLowerCase(),
            index: buttonForm.index - 1,
          };

          if (buttonForm.key === 'QUICK_REPLY') {
            buttonConfig.parameters = [
              {type: 'payload', payload: formValues[buttonForm.name]}
            ];
          } else if (buttonForm.key === 'URL') {
            buttonConfig.parameters = [
              {type: 'text', text: formValues[buttonForm.name]}
            ];
          }

          template.components.push(buttonConfig);
        }
      }

      template.preview = '';
      const headerValue = this.previewHeader();
      const bodyValue = this.previewBody();

      if (headerValue) {
        template.preview += headerValue + '\n\n';
      }
      template.preview += bodyValue;

      if (this.templateFooterObj?.text) {
        template.preview += '\n\n' + this.templateFooterObj?.text;
      }

      this.dialogRef.close({template: template, file: this.file1});
    }
  }
}
